/**
 * Pulse signs the operator out of this app only. Microsoft's end-session
 * redirect is never used — that would also clear Outlook / Teams SSO.
 *
 * After a local clear, Protected reads this flag and shows a signed-out
 * screen instead of silently re-acquiring an Entra token via SSO.
 */
export const LOCAL_SIGNED_OUT_KEY = 'pulse:local-signed-out'
export const LOCAL_SIGN_OUT_CHANGE_EVENT = 'pulse:local-sign-out-change'

function emitLocalSignOutChange(): void {
  try {
    window.dispatchEvent(new Event(LOCAL_SIGN_OUT_CHANGE_EVENT))
  } catch {
    // Non-browser tests/imports can still use the storage helpers.
  }
}

export function markLocallySignedOut(): void {
  try {
    sessionStorage.setItem(LOCAL_SIGNED_OUT_KEY, '1')
  } catch {
    // private mode / blocked storage — Protected still sees an empty account list
  }
  emitLocalSignOutChange()
}

export function clearLocallySignedOut(): void {
  try {
    sessionStorage.removeItem(LOCAL_SIGNED_OUT_KEY)
  } catch {
    // ignore
  }
  emitLocalSignOutChange()
}

export function isLocallySignedOut(): boolean {
  try {
    return sessionStorage.getItem(LOCAL_SIGNED_OUT_KEY) === '1'
  } catch {
    return false
  }
}

export function subscribeLocalSignOut(listener: () => void): () => void {
  window.addEventListener(LOCAL_SIGN_OUT_CHANGE_EVENT, listener)
  return () => window.removeEventListener(LOCAL_SIGN_OUT_CHANGE_EVENT, listener)
}
